import { Link } from "react-router-dom";
import type { DocMeta } from "../../shared/types";
import { AUDIENCE_LABEL, KIND_LABEL, STATUS_LABEL } from "../../shared/types";
import { formatDate, splitSnippet } from "../format";

export default function DocCard({ doc }: { doc: DocMeta }) {
  return (
    <Link className="card" to={`/d/${doc.slug}`}>
      <div className="card-head">
        <h2 className="card-title">{doc.title}</h2>
        <span className={`badge badge-${doc.status}`}>{STATUS_LABEL[doc.status]}</span>
      </div>

      {doc.snippet ? (
        <p className="card-summary">
          {splitSnippet(doc.snippet).map((part, index) =>
            part.hit ? <mark key={index}>{part.text}</mark> : <span key={index}>{part.text}</span>,
          )}
        </p>
      ) : (
        doc.summary && <p className="card-summary">{doc.summary}</p>
      )}

      <div className="card-meta">
        <span className="tag">{KIND_LABEL[doc.kind]}</span>
        <span className="tag">{AUDIENCE_LABEL[doc.audience]}</span>
        {doc.team && <span className="tag tag-team">{doc.team}</span>}
        <span>
          {doc.updated_by} · updated {formatDate(doc.updated_at)} · {doc.read_minutes} min
        </span>
      </div>
    </Link>
  );
}
